import Alert from '@material-ui/lab/Alert';
import React from 'react';
import { useObservable } from 'react-use-observable';
import { numberToBRL } from 'v2/helpers/money';
import { anticipationService } from 'v2/services/anticipation';

import styles from '../styles';

function AnticipateStep() {
  const classes = styles();

  const [anticipationBalance] = useObservable(() => anticipationService.getCurrentBalance(), []);
  const anticipationFormatted = typeof anticipationBalance === 'number' ? numberToBRL(anticipationBalance) : '-';

  return (
    <>
      <p className={classes.subtitle}>Saldo disponível para antecipação</p>
      <div className={classes.valueAvailable}>
        <span>Valor:</span>
        <strong>{anticipationFormatted}</strong>
      </div>

      <div className={classes.alertList}>
        <Alert className={classes.alertItem} severity='info'>
          Você tem <strong>{anticipationFormatted}</strong> disponível para antecipação, deseja antecipar o valor?
        </Alert>
      </div>
    </>
  );
}

export default AnticipateStep;
